export var MOBILE_BREAKPOINT = 480;
export var IS_PROD = process.env.CHEGG_ENV === 'prod';